const baseStaticMapUrl = "https://maps.googleapis.com/maps/api/staticmap";
export const baseMapUrl = "https://www.google.com/maps/place/";
export const address1 = "20422 Beach Blvd #215";
export const address2 = "Huntington Beach, CA 92648";
export const encodedAddress = `${encodeURIComponent(address1.replace(" ", "+"))},${encodeURIComponent(
  address2.replace(" ", "+")
)}`;

export const mapLoader = ({ src, width }) => `${baseStaticMapUrl}${src}&size=${width}x${width}`;
